import React from "react";
import { Box, Card, Skeleton, Stack, Typography } from "@mui/material";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import { IconTile, Pill } from "./ui";

// Legacy hex colors -> design-system tones (keeps old callers working).
const COLOR_TONES = {
  "#257bf4": "primary",
  "#1976d2": "primary",
  "#8b5cf6": "violet",
  "#7c3aed": "violet",
  "#22c55e": "success",
  "#16a34a": "success",
  "#f59e0b": "warning",
  "#d97706": "warning",
  "#ef4444": "error",
  "#dc2626": "error",
};

/** KPI card (Accss design system v2). Prefer `tone`; `color` is accepted for backward compatibility. */
export default function StatsCard({ icon, label, value, subtitle, tone, color, trend, loading, action }) {
  const resolvedTone = tone || COLOR_TONES[String(color || "").toLowerCase()] || "primary";
  return (
    <Card sx={{ height: "100%", p: 2.5, display: "flex", flexDirection: "column", gap: 1.75 }}>
      <Stack direction="row" alignItems="center" spacing={1.25}>
        <IconTile tone={resolvedTone} size={38}>
          {icon}
        </IconTile>
        <Typography variant="subtitle2" component="h3" sx={{ flex: 1, minWidth: 0, color: "text.secondary" }} noWrap>
          {label}
        </Typography>
        {trend ? (
          <Pill tone={trend > 0 ? "success" : "error"}>
            {trend > 0 ? <TrendingUpIcon sx={{ fontSize: 14 }} /> : <TrendingDownIcon sx={{ fontSize: 14 }} />}
            {Math.abs(trend)}%
          </Pill>
        ) : null}
      </Stack>

      <Box>
        {loading ? (
          <Skeleton variant="rounded" width="55%" height={34} />
        ) : (
          <Typography sx={{ fontSize: "1.85rem", fontWeight: 800, lineHeight: 1.1, letterSpacing: "-0.02em" }}>{value}</Typography>
        )}
        {subtitle ? (
          <Typography variant="body2" sx={{ color: "text.secondary", mt: 0.75 }} noWrap>
            {loading ? <Skeleton width="40%" /> : subtitle}
          </Typography>
        ) : null}
      </Box>
      {action ? <Box sx={{ mt: "auto" }}>{action}</Box> : null}
    </Card>
  );
}
